import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input"> & { error?: boolean; startIcon?: React.ReactNode; endIcon?: React.ReactNode }>(
  ({ className, type, error, startIcon, endIcon, ...props }, ref) => {
    return startIcon || endIcon ? (
      <div className="relative">
        <input
          type={type}
          className={cn(
            "flex h-10 w-full bg-input text-foreground border rounded-lg px-3 py-3 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
            className,
            error && "border border-destructive bg-destructive/10 font-bold text-destructive",
            startIcon && "pl-8",
            endIcon && "pr-8"
          )}
          value={props.value === null ? "" : props.value === undefined ? undefined : props.value}
          ref={ref}
          {...props}
        />
        {startIcon && <span className="absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground">{startIcon}</span>}
        {endIcon && <span className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground">{endIcon}</span>}
      </div>
    ) : (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full bg-input text-foreground border rounded-lg px-3 py-3 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
          error && "border border-destructive bg-destructive/10 font-bold text-destructive"
        )}
        value={props.value === null ? "" : props.value === undefined ? undefined : props.value}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
